import React from 'react';
import OfferWithHotelElement from './components/list-element';
import {
  fetchFilterData,
  createRegionsObject,
  localstorageAvailable,
  isFilterExpired
} from '../../../../../../services/services';

const filterDataCacheTime = 900000;

const OfferWithHotelList = props => {
  const regions = setInitialData();
  return (
    <div className="offer-list-wrapper">
      {props.data.map((element, index) => {
        let preloadclass =
          (index % 10) + 1 == props.preloadPoint ? 'preload-offers' : '';
        return (
          <OfferWithHotelElement
            offer_type={props.offer_type}
            data={element}
            key={`${element.id}${index}`}
            params={props.params}
            preloadClass={preloadclass}
            regions={regions}
          />
        );
      })}
    </div>
  );
};

const setInitialData = () => {
  if (localstorageAvailable()) {
    if (isFilterExpired('regions', filterDataCacheTime)) {
      return updateFilterSource();
    } else {
      const filter_data = JSON.parse(localStorage.getItem('regions_filter'));
      return filter_data.regions;
    }
  } else {
    return updateFilterSource();
  }
};

const updateFilterSource = () => {
  fetchFilterData('regions_filter').then(
    response => {
      const filter_data = createRegionsObject(response.data);
      if (localstorageAvailable()) {
        localStorage.setItem('regions_filter', JSON.stringify(filter_data));
        localStorage.setItem(
          'regions_filter_last_update',
          new Date().getTime()
        );
      }
      return filter_data.regions;
    },
    error => {
      console.log('Error when fetching regions filter', error);
    }
  );
};

export default OfferWithHotelList;



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/components/offers_list/components/with-hotel/index.js